import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import {
  SystemParam,
  SystemParamSubject,
} from "src/app/shared/models/order.model";
import { DataService } from "src/app/shared/services/data.service";
import { Store } from "@ngrx/store";
import { systemParams } from "src/app/shared/ngrx/ngrx-selectors";
import { CommonModule } from "@angular/common";
import { ParamBoxComponent } from "./param-box/param-box.component";
import { LoaderComponent } from "src/app/shared/components/ui/loader/loader.component";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-mng-params",
  templateUrl: "./mng-params.component.html",
  styleUrls: ["./mng-params.component.scss"],
  standalone: true,
  imports: [CommonModule, ParamBoxComponent, LoaderComponent],
})
export class MngParamsComponent implements OnInit {
  get params(): SystemParamSubject[] {
    return this.store.selectSignal(systemParams)();
  }

  constructor(
    private readonly store: Store,
    private dataService: DataService
  ) {}

  ngOnInit(): void {
    if (this.params.length == 0) {
      this.loadParams();
    }
  }

  loadParams() {
    this.dataService.getSystemParams().subscribe();
  }
}
